import { makeUserManager } from 'react-oidc';
import { UserManager } from 'oidc-client';
import { createConfig } from './oidc-auth-config';
import { sendAccessTokenWithHttpRequests } from './auth-axios-interceptor';
import { configuration } from '../configuration';
import { AuthConfig } from './auth-config';
import { endSessionWhenLoggedOutElsewhere } from './logged-out-elsewhere';

let userManager: UserManager | null = null;

export function initializeAuthentication(config: AuthConfig): UserManager | null {
  const oidcConfig = createConfig(config);
  userManager = makeUserManager(oidcConfig);
  sendAccessTokenWithHttpRequests(userManager);
  endSessionWhenLoggedOutElsewhere(userManager);
  return userManager;
}

export function getUserManager(): UserManager | null {
  return userManager;
}
